module.exports = __webpack_public_path__ + "images/map/map-marker-678a316bfa30f30af82dc8e452e5d84d.png";